import {AIAgentData, IMindMapModalData, GradeStatus} from './interface';

const AIGCInstanceRef = {current: null};

export const getDefaultAIAgentData = (): AIAgentData => {
    return {
        docDomReady: false,
        AIGCPluginReady: false,
        AIGCInstanceRef,
        gradeStatus: GradeStatus.Init,
        grading: false,
        manualGrade: false,
        score: null,
        scoreUpdateType: 'request',
        wordCount: 0,
        hasNewGrade: false,
        optimizeList: [],
        updateType: 'request',
        socketError: false,
        noTips: false,
    };
};

export const DefaultMindMapModalData: IMindMapModalData = {
    visible: false,
    type: 'list',
    mindmapSvg: '',
    listMd: '',
    width: 0,
    height: 0,
};
